import { Form, Space, Tooltip } from 'antd';
import { RegionLangSelect } from 'components/Langs/RegionLangSelect';
import { useFormikContext } from 'formik';
import { FV } from './share';
import { useRegionLanguageMap } from 'hooks/business/system/useRegionLanguage';
import { useTranslate } from '@tolgee/react';
import useSmartField from 'hooks/useSmartField';
import { What } from 'views/Aide/Scenario/PolicyTable';
import { useMount, useUpdateEffect } from 'ahooks';
import { DisabledProps } from 'views/Aide/Scenario/TaskForm/share';

function Language({ disabled }: DisabledProps) {
  const { t } = useTranslate();

  const {
    field: { value, onChange },
  } = useSmartField<FV['language']>('language');

  const regionLanguageMap = useRegionLanguageMap();

  const {
    values: { stores },
  } = useFormikContext<FV>();

  const region = stores?.[0]?.region;

  useUpdateEffect(() => {
    onChange(region ? regionLanguageMap[region] : undefined);
  }, [region]);
  useMount(() => {
    if (!value) {
      onChange(region ? regionLanguageMap[region] : undefined);
    }
  });

  if (!value || !region) {
    return null;
  }

  return (
    <Form.Item label={t('生成为')}>
      <Space>
        <RegionLangSelect
          disabled={disabled}
          className="!w-[auto]"
          region={region}
          value={value}
          onChange={onChange}
        />
        <Tooltip title={t('生成语言tips')}>
          <What />
        </Tooltip>
      </Space>
    </Form.Item>
  );
}

export default Language;
